import * as ramda from 'ramda';

export const getValue = (key: string, row: any, isLeadCard?: boolean) => {
    if (!row || !row.fields) return undefined;

    const value = ramda.has(key)(row.fields) ? row.fields[key] : undefined;

    // Return only first contact or account for lead card
    if (
        value &&
        value.value &&
        value.value.length &&
        isLeadCard &&
        (key === 'accounts' || key === 'contacts')
    ) {
        return {value: [value.value[0]]};
    } else {
        return value;
    }
};

export const getTitle = (field: any, isLeadCard?: boolean) => {
    if (!isLeadCard) {
        return field.title;
    }

    switch (field.name) {
        case 'accounts':
            return 'Related company';
        case 'contacts':
            return 'Related person';
        default:
            return field.title;
    }
};
